import { HpInputControlProps } from '../../../types/inputControlTypes';
import { CommonImageButtonListControl, HpCreateCustomOptionWidgetFunc } from '../common/commonImageButtonListControl';

export interface HpImageButtonListControlProps extends HpInputControlProps {
  title?: string;
  isMultiSelect: boolean;
  createCustomOptionWidget?: HpCreateCustomOptionWidgetFunc;
}

export function ImageButtonListControl(props: HpImageButtonListControlProps): JSX.Element {
  return <CommonImageButtonListControl listType={props.isMultiSelect ? 'CheckBox' : 'Radio'} {...props} />;
}
